<template>
	<div class="monitoring-ticket">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Monitoring Ticket</h1>
				<div class="page-header-right text-right ml-a">
					<!-- Date Filter -->
					<daterangepicker
						:presets="filterDatePresets"
						:start="since"
						:end="until"
						@selected="setFilterDate"
						ref="datePicker"
					>
					</daterangepicker>
				</div>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-6">
							<!-- Search Keyword -->
							<input
								type="text"
								class="input
								form-control form-control-sm users-search-box w-50"
								placeholder="Search ..."
								autocomplete="off"
								@input="onKeywordChange"
								v-model="keyword"
							/>
						</div>
						<div class="col-sm-6">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
								<!-- <button type="button" class="btn btn-light flex-center mr-2" @click="isShowFilter = true">
									<i class="material-icons mr-1">filter_list</i>Filter
								</button> -->
							</div>
						</div>
					</div>
				</div>
				<!-- Ticket List -->
				<div class="users-list table-responsive">
					<table class="users-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="3%">
									No
								</th>
								<th width="6%" :class="sortClass('ticket_id')"
									@click="changeSorting('ticket_id')" >
									ID Ticket
								</th>
								<th width="10%" class="text-left" :class="sortClass('type')"
									@click="changeSorting('type')" >
									Type
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('product.name')"
									@click="changeSorting('product.name')">
									Product Name
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('supplier.name')"
									@click="changeSorting('supplier.name')">
									Supplier Name
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('status')"
									@click="changeSorting('status')">
									Status
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('created_at')"
									@click="changeSorting('created_at')">
									Created at
								</th>
								<th width="10%" class="text-left">
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in items" :key="'list-'+ index" @click="openNoteModal(item, $event)">
								<td class="text-center">
									{{ index+1 }}
								</td>
								<td class="text-center">
									{{ handleEmpty(item.ticket_id) }}
								</td>
								<td>
									{{ getType(item.type) }}
								</td>
								<td>
									<a :href="'/admin/products?product_id=' + item.product_id" target="_blank">
										{{ item.product.name }}
									</a>
								</td>
								<td>
									{{ item.supplier.name }}
								</td>
								<td>
									<div class="row">
										<div class="col-7">
											<span :class="item.status" class="btn btn-sm">
												{{ getStatus(item.status) }}
											</span>
										</div>
										<div class="col-5">
											<span class="note ml-3 hidden-sm text-primary" role="button">
												<i class="bi bi-card-text" v-tooltip="getNotificationDetail(item)"></i>
											</span>
										</div>
									</div>
								</td>
								<td>
									{{ formatDate(moment, item.created_at, 'DD-MM-YYYY HH:mm:ss') }}
								</td>
								<td>
									<div class="btn-group">
										<button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
											{{ $t('Action') }}
										</button>
										<div class="dropdown-menu">
											<button
												class="dropdown-item"
												@click="openStatusModal(item)"
											>
												Change Status
											</button>
											<a :href="`https://wa.me/62${validatePhoneNumber(item.supplier.phone)}?text=${getNotificationDetail(item)}`" class="dropdown-item text-decoration-none" target="_blank">
												Follow up
											</a>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Ticket yet.</span>
						<span v-else>No Ticket was found</span>
					</div>
				</div>
			</div>
		</div>
		<div class="modals">
			<modal
				class="table-filter-modal"
				size="medium"
				@close="isUpdateStatusModal = false"
				v-if="isUpdateStatusModal">
			<div slot="header">
				<h3>Update Ticket</h3>
			</div>
			<div slot="body">
				<div class="form-group">
					<label for="">
						<b class="">
							Status Ticket
						</b>
					</label>
					<select class="form-control" v-model="selectedTicket.status">
						<option v-for="(item, index) in optionStatusTicket" :key="'option-status-'+index" :value="item.key">{{item.label}}</option>
					</select>
				</div>
				<div class="form-group" v-if="selectedTicket.status === 'closed'">
					<label for="">
						<b class="">
							Reason
						</b>
					</label>
					<textarea
						v-model="selectedTicket.reason"
						class="form-control"
						:class="{'is-invalid' : errorForm.reason}"
						@input="onReasonChange"
					>
					</textarea>
					<div class="invalid-feedback" v-if="errorForm.reason">
						{{ this.errorForm.reason }}
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isUpdateStatusModal = false">{{ $t('Close') }}</button>
				<button type="button" :class="{'is-loading' : isUpdating }" class="btn btn-primary" @click="changeStatus">Apply</button>
			</div>
			</modal>
		</div>
		<div class="modals">
			<modal
				class="table-filter-modal"
				size="large"
				@close="isOpenNoteModal = false"
				v-if="isOpenNoteModal">
				<div slot="header">
					<h3>Detail Ticket monitoring</h3>
				</div>
				<div slot="body">
					<ticket-loading :is-fetching="isFetchingDetail" v-if="isFetchingDetail"/>
					<div class="ticket" v-else>
						<div class="ticket-info">
							<div class="info-row">
								<span class="text-bold">{{ $t('Ticket ID') }}:</span>
								<span class="ml-1">{{handleEmpty(selectedTicket.ticket_id)}}</span>
							</div>
							<div class="info-row">
								<span class="text-bold">{{ $t('Supplier Name') }}:</span>
								<span class="ml-1">{{handleEmpty(selectedTicket.supplier.name)}}</span>
							</div>
							<div class="info-row">
								<span class="text-bold">{{ $t('Type') }}:</span>
								<span class="ml-1">{{ getType(selectedTicket.type) }}</span>
							</div>
							<div class="info-row">
								<span class="text-bold">{{ $t('Status Ticket') }}:</span>
								<span class="ml-1">{{ getStatus(selectedTicket.status) }}</span>
							</div>
							<div class="info-row" v-if="selectedTicket.reason">
								<span class="text-bold">{{ $t('Reason') }}:</span>
								<span class="ml-1">{{ handleEmpty(selectedTicket.reason) }}</span>
							</div>
						</div>
						<ticket-message :list-message="listMessage" :user-data="user"/>
						<div class="form-group mb-1 mt-4">
							<label class="text-bold">
								Tulis catatan tiket
							</label>
							<textarea
								class="form-control"
								rows="2"
								placeholder="Tulis pesan anda di sini"
								v-model="content">
							</textarea>
						</div>
					</div>
				</div>

				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isOpenNoteModal = false">{{ $t('Close') }}</button>
					<button type="button" :class="{'is-loading' : isUpdating }" class="btn btn-primary" @click="saveMessage">Send</button>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import Daterangepicker from '@/components/Daterangepicker.vue';
import Modal from '@/components/Modal.vue';
import TicketLoading from '@/components/admin/ticket/TicketLoading.vue';
import TicketMessage from '@/components/admin/ticket/TicketMessage.vue';
import {
	duplicateVar,
	getDateRange,
	formatDate,
	toTitleCase,
	validatePhoneNumber,
} from '@/lib/helper';
import { defaultOptionStatusTicket } from '@/lib/statics';
import adminApi from '@/api/admin';

export default {
	name: 'AdminTicket',
	components: {
		Daterangepicker,
		Modal,
		TicketMessage,
		TicketLoading,
	},
	data() {
		return {
			keyword: '',
			since: '',
			until: '',
			limit: 25,
			sort_by: 'created_at',
			sort: 'desc',
			selectAll: '',
			event: '',
			isFetching: false,
			isFetchingDetail: false,
			items: [],
			isShowDetail: false,
			isUpdateStatusModal: false,
			selectedStatus: 'open',
			selectedId: '',
			selectedTicket: {},
			listMessage: [],
			isUpdating: false,
			isOpenNoteModal: false,
			content: '',
			optionStatusTicket: defaultOptionStatusTicket,
			reason: '',
			errorForm: {
				reason: '',
			},
		};
	},
	methods: {
		handleEmpty(variable) {
			return variable ?? '-';
		},
		onReasonChange(event) {
			const reason = event.target.value;
			this.reason = reason;
		},
		getNotificationDetail(item) {
			let message = '';
			if (item.type === 'stock-notification') {
				message = `Berdasarkan perhitungan dari rata-rata pembelian, maka stok diperkirakan akan habis dalam ${item?.data?.remaining_days} hari kedepan`;
			}

			if (item.status === 'resolved') {
				message = 'Status ticket is Resolved';
			}

			if (item.status === 'closed') {
				message = 'Status ticket is Closed';
			}

			return message;
		},
		saveMessage() {
			this.isUpdating = true;
			const params = {
				ticket: this.selectedTicket,
				content: this.content,
			};

			const callback = (response) => {
				this.isUpdating = false;
				this.content = '';
				this.listMessage.push(response.data);
			};

			const errorCallback = () => {
				this.isUpdating = false;
				this.$notify({
					group: 'app',
					title: 'Monitoring ticket',
					text: 'Failed to update status ticket',
					type: 'error',
				});
			};

			adminApi.saveMessageTicket(params, callback, errorCallback);
		},
		getType(type) {
			return toTitleCase(type.replace('-', ' '));
		},
		getStatus(status) {
			return toTitleCase(status.replace('_', ' '));
		},
		resetStatusParam() {
			this.selectedTicket = {};
			this.reason = '';
		},
		changeStatus() {
			if (this.selectedTicket.status === 'closed') {
				this.validateReason();

				const isErrorExist = Object.values(this.errorForm).find(val => val !== '');

				if (isErrorExist) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed',
						text: 'Form harus diisi.',
					});
					return;
				}
			}

			this.isUpdating = true;
			const params = {
				status: this.selectedTicket.status,
				selected_id: this.selectedTicket._id,
			};

			if (this.reason !== '') {
				params.reason = this.reason;
			}

			const callback = (response) => {
				this.isUpdating = false;
				this.isUpdateStatusModal = false;
				this.resetStatusParam();
				if (response?.data?.http_code !== 400) {
					const filter = this.items.find(ticket => ticket._id === response.data._id);
					filter.status = response.data.status;
					filter.reason = response?.data?.reason ?? '';

					this.$notify({
						group: 'app',
						title: 'Monitoring ticket',
						text: 'Succesfully update status ticket',
						type: 'success',
					});
				}
			};

			const errorCallback = () => {
				this.isUpdating = false;
				this.resetStatusParam();
				this.$notify({
					group: 'app',
					title: 'Monitoring ticket',
					text: 'Failed to update status ticket',
					type: 'error',
				});
			};

			adminApi.updateTicket(params, callback, errorCallback);
		},
		openStatusModal(ticket) {
			this.selectedTicket = duplicateVar(ticket);
			this.isUpdateStatusModal = true;
		},
		openNoteModal(ticket, event) {
			this.isFetchingDetail = true;
			if (event.target.tagName.toLowerCase() === 'button' || event.target.tagName.toLowerCase() === 'a') {
				return;
			}
			this.selectedTicket = duplicateVar(ticket);
			this.isOpenNoteModal = true;

			const params = {
				ticket_id: this.selectedTicket._id,
			};

			const callback = (response) => {
				this.isFetchingDetail = false;
				this.listMessage = response.data;
			};

			const errorCallback = () => {
				this.isFetchingDetail = false;
				this.resetStatusParam();
				this.$notify({
					group: 'app',
					title: 'Monitoring ticket',
					text: 'Failed to update status ticket',
					type: 'error',
				});
			};
			adminApi.listTicketMessage(params, callback, errorCallback);
		},
		toTitleCase,
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: this.since,
				until: this.until,
			};

			if (this.keyword !== '') {
				params.keyword = this.keyword;
			}

			if (this.ticketId) {
				params.ticket_id = this.ticketId;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				const items = response.data;
				this.isUpdateStatusModal = false;
				if (items.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			adminApi.listTicket(params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const dateFormat = 'YYYY-MM-DD';
			const since = dayjs(filterDate.start).format(dateFormat);
			const until = dayjs(filterDate.end).format(dateFormat);
			this.since = since;
			this.until = until;
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchItems(true);
		},
		initFilterDate() {
			const dateRange = getDateRange();
			const hasSinceQuery = this.sinceQuery && this.sinceQuery !== '';
			const hasUntilQuery = this.untilQuery && this.untilQuery !== '';
			const sinceDate = hasSinceQuery
				? dayjs(this.sinceQuery)
				: dayjs(dateRange.start);
			const untilDate = hasUntilQuery
				? dayjs(this.untilQuery)
				: dayjs(dateRange.end);
			const filterDate = {
				start: sinceDate,
				end: untilDate,
			};
			this.filterDate = filterDate;

			const dateFormat = 'YYYY-MM-DD';
			this.since = sinceDate.format(dateFormat);
			this.until = untilDate.format(dateFormat);
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetFilter() {
			this.event = '';
			this.keyword = '';
			if (!this.ticketId) {
				this.fetchItems(true);
			}
		},
		clearFilter() {
			this.$router.replace({ query: null });
			this.resetFilter();
		},
		validateReason() {
			this.errorForm.reason = '';
			if (this.reason.trim() === '') {
				this.errorForm.reason = 'Form Reason wajib diisi';
			}
		},
		onKeywordChange() {
			this.ooDelay(() => {
				if (this.isAdmin) {
					this.fetchItems();
				} else if (this.isSupport) {
					if (this.keyword.trim() === '') {
						this.resetItems();
					} else {
						this.fetchItems();
					}
				}
			}, 1000);
		},
		initData() {
			this.initFilterDate();
			this.fetchItems(true);
		},
		validatePhoneNumber,
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			filterDatePresets: 'filterDatePresets',
		}),
		sinceQuery() {
			const since = this.$route.query.since;
			return since;
		},
		untilQuery() {
			const until = this.$route.query.until;
			return until;
		},
		isFilterOn() {
			return this.keyword !== ''
				|| this.event !== '' || this.ticketId;
		},
		ticketId() {
			return this.$route?.query?.ticket_id ?? null;
		},
	},
	watch: {
		'$route.query.ticket_id': {
			handler() {
				this.fetchItems(true);
			},
		},
	},
	created() {
		this.initData();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>

.closed{
	color: white;
	border-color: #e74c3c;
    background-color: #e74c3c;
}

.resolved{
	color: white;
	border-color: #139a4b;
    background-color: #139a4b;
}

.in_progress{
	color: white;
	border-color: #5faded;
    background-color: #3498db;
}

.open {
	color: #7f8c8d;
	border-color: #d9dee2;
    background-color: #f5f5f5;
}

</style>
